export const TABLE_HEAD = ['API name', 'Status', 'Created date', 'Actions'];
